var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1666 18.3334H38.2489C37.4529 9.55336 30.4466 2.54711 21.6666 1.75109V0.833359C21.6666 0.372734 21.294 0 20.8334 0H19.1667C18.7061 0 18.3334 0.372734 18.3334 0.833359V1.75109C9.55336 2.54711 2.54711 9.55336 1.75109 18.3334H0.833359C0.372734 18.3334 0 18.7061 0 19.1666V20.8333C0 21.2939 0.372734 21.6666 0.833359 21.6666H1.75109C2.54711 30.4466 9.55328 37.4529 18.3334 38.2489V39.1666C18.3334 39.6273 18.7061 40 19.1667 40H20.8334C21.294 40 21.6667 39.6273 21.6667 39.1666V38.2489C30.4467 37.4529 37.453 30.4467 38.249 21.6666H39.1667C39.6273 21.6666 40.0001 21.2939 40.0001 20.8333V19.1666C40 18.7061 39.6273 18.3334 39.1666 18.3334ZM33.3334 21.6666H34.9016C34.1302 28.607 28.6078 34.1302 21.6666 34.9017V33.3333C21.6666 32.8727 21.2939 32.4999 20.8333 32.4999H19.1666C18.706 32.4999 18.3333 32.8727 18.3333 33.3333V34.9017C11.3922 34.1302 5.86977 28.607 5.09828 21.6666H6.66656C7.12719 21.6666 7.49992 21.2939 7.49992 20.8333V19.1666C7.49992 18.706 7.12719 18.3333 6.66656 18.3333H5.09836C5.86984 11.3929 11.3922 5.86977 18.3334 5.0982V6.66664C18.3334 7.12727 18.7061 7.5 19.1667 7.5H20.8334C21.294 7.5 21.6667 7.12727 21.6667 6.66664V5.09828C28.6078 5.86984 34.1302 11.393 34.9017 18.3334H33.3334C32.8728 18.3334 32.5001 18.7061 32.5001 19.1667V20.8334C32.5 21.294 32.8727 21.6666 33.3334 21.6666Z",
    fill: "#CECABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20C22.3011 20 24.1665 18.1346 24.1665 15.8334C24.1665 13.5322 22.3011 11.6667 19.9999 11.6667C17.6987 11.6667 15.8333 13.5322 15.8333 15.8334C15.8333 18.1346 17.6987 20 19.9999 20Z",
    fill: "#CECABE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6998 22.5529C24.3684 21.7684 22.2981 20.8334 20 20.8334C17.7019 20.8334 15.6315 21.7685 14.3002 22.5529C13.1901 23.2081 12.5 24.48 12.5 25.8724V26.4063C12.5 27.4691 13.3008 28.3334 14.2855 28.3334H25.7145C26.6992 28.3334 27.5 27.4691 27.5 26.4063V25.8724C27.5 24.48 26.8099 23.2081 25.6998 22.5529Z",
    fill: "#CECABE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.55db851eded2bc61ece54a041306937a.svg";
export { ForwardRef as ReactComponent };